import omit from 'lodash/omit';
import styled, { CSSProperties } from 'styled-components';

import { Heading } from '~src/components/Typography';
import { TAKEOVER_OVERLAY_TEXT } from '~src/constants';
import { useDisplay } from '~src/hooks/useDisplay';
import { Address, AddressWithGeolocation } from '~src/model';

import { formatAddress } from '~src/util';

const TakeoverOverlayBackground = styled.div({
  backdropFilter: 'blur(7px)',
  height: '100%',
  width: '100%',
  position: 'absolute',
  right: 0,
  top: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const TakeoverOverlayTextWrapper = styled.div({});

type TakeoverOverlayProps = {
  address?: Address | AddressWithGeolocation;
  style?: CSSProperties;
  text?: string;
};

export const TakeoverOverlay = ({ address, style, text = TAKEOVER_OVERLAY_TEXT }: TakeoverOverlayProps) => {
  const { isMobile } = useDisplay();

  return (
    <TakeoverOverlayBackground>
      <TakeoverOverlayTextWrapper style={style}>
        <Heading color='light' style={{ fontSize: isMobile ? '20px' : '32px', lineHeight: isMobile ? '40px' : '51px' }}>
          {text}
        </Heading>

        <Heading
          color='light'
          style={{
            fontSize: isMobile ? '14px' : '20px',
            lineHeight: '27px',
            marginTop: '24px',
            textAlign: 'center',
          }}
        >
          {address ? formatAddress(omit(address, ['id'])) : ''}
        </Heading>
      </TakeoverOverlayTextWrapper>
    </TakeoverOverlayBackground>
  );
};
